import React, { Component } from "react";
import './App.scss';
import {BrowserRouter, Switch, Route} from "react-router-dom";
import queryString  from "query-string";

import {TextGrid} from "./TextGrid";

class GridDecision extends Component {
    constructor() {
        super();

        this.state = {
            parsed: queryString.parse(window.location.search)
        };
    }

    render() {
        return (
        <>
            <TextGrid useControls={this.state.parsed.controls === "1"} contentEditable="true"/>
        </>
        );
    }
}

class App extends Component {
    constructor() {
        super();

        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <BrowserRouter>
                <div style={{ textAlign: "center" }}>
                    <Switch>
                        <Route path="/">
                            <GridDecision />
                        </Route>
                    </Switch>
                </div>
            </BrowserRouter>
        );
    }
}

export default App;
